import { render, staticRenderFns } from "./page-belt.vue?vue&type=template&id=6b5f5350&lang=pug&"
import script from "./page-belt.vue?vue&type=script&lang=js&"
export * from "./page-belt.vue?vue&type=script&lang=js&"
import style0 from "./page-belt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports